import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f34a3f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "言語の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "英語力")
], -1))
const _hoisted_5 = { class: "careersheet_input_layout_column_1" }
const _hoisted_6 = { class: "careersheet_input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "その他言語")
], -1))
const _hoisted_8 = { class: "careersheet_input_layout_column_1" }
const _hoisted_9 = {
  key: 0,
  class: "careersheet_language_add"
}
const _hoisted_10 = { class: "careersheet_button" }
const _hoisted_11 = { class: "careersheet_button_prev" }
const _hoisted_12 = { class: "careersheet_button_next" }

import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import { ref, Ref, computed } from 'vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkillLanguageEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// 言語情報取得
const engsklId: Ref<number | null> = ref(store.getters['careerSheetLanguage/engsklId']);
const otrlangIdArray: Ref<(number | null)[]> = ref([]);

const addOtrlangId = () => {
  otrlangIdArray.value.push(null);
};

const init = () => {
  const otrlang1Id: number | null = store.getters['careerSheetLanguage/otrlang1Id'];
  const otrlang2Id: number | null = store.getters['careerSheetLanguage/otrlang2Id'];
  const otrlang3Id: number | null = store.getters['careerSheetLanguage/otrlang3Id'];
  if (otrlang1Id !== null) {
    otrlangIdArray.value.push(otrlang1Id);
  }
  if (otrlang2Id !== null) {
    otrlangIdArray.value.push(otrlang2Id);
  }
  if (otrlang3Id !== null) {
    otrlangIdArray.value.push(otrlang3Id);
  }
  if (otrlangIdArray.value.length === 0) {
    otrlangIdArray.value.push(null);
  }
};
init();

// 言語マスタ取得
const mstLangSklOptions: Ref<{ label: string; subLabel: string; value: number }[]> = computed(
  () => store.getters['master/mstListLanguageOptions']
);
const mstOtrLangSklOptions: Ref<Options> = computed(() => store.getters['master/mstListOtrLanguageOptions']);

const transitionConfirmPage = () => {
  const newOtrlangIdArray = otrlangIdArray.value.filter((i) => i !== null);
  const param = {
    engsklId: engsklId.value,
    otrlang1Id: newOtrlangIdArray[0] || null,
    otrlang2Id: newOtrlangIdArray[1] || null,
    otrlang3Id: newOtrlangIdArray[2] || null,
  };
  store.commit('careerSheetLanguage/set', param);
  if (route.query.ref === 'e') {
    router.push({ name: 'e56', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e56' });
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e50', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n50' });
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mstLangSklOptions), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "careersheet_input_layout_column_1_item",
            key: item.value
          }, [
            _createVNode(BaseRadioButton, {
              modelValue: engsklId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((engsklId).value = $event)),
              value: item.value,
              name: "english",
              label: item.label,
              subLabel: item.subLabel
            }, null, 8, ["modelValue", "value", "label", "subLabel"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otrlangIdArray.value, (otrlangId, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "careersheet_input_layout_column_1_item",
            key: index
          }, [
            _createVNode(BaseSelectBox, {
              placeholder: "その他言語を選択",
              options: _unref(mstOtrLangSklOptions),
              modelValue: otrlangIdArray.value[index],
              "onUpdate:modelValue": ($event: any) => ((otrlangIdArray.value[index]) = $event),
              hasCancelButton: ""
            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      ])
    ]),
    (otrlangIdArray.value.length < 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "button_text",
            onClick: addOtrlangId
          }, "＋その他言語をさらに入力")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          onClick: transitionConfirmPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("確認する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})